/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {DiversionEditor}     from './diversion.editor';

/**
 *
 * @class SetStdDevCommand
 *
 * @brief reversible updates of standard deviation
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetStdDevCommand implements ICommand {

  private oldValue: number;
  private newValue: number;
  private editor:   DiversionEditor;

  constructor(oldValue: number, newValue: number, editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setStdDev(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setStdDev(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[begin] ' + this.oldValue + ' => ' + this.newValue;
  }

}
